/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsIsKnownExploitedVulnerabilityQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AppSecopsIsKnownExploitedVulnerabilityQueryOperator");
    }

    getFixupPrototypeFunction() { return AppSecopsIsKnownExploitedVulnerabilityQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsIsKnownExploitedVulnerabilityQueryOperator>): AppSecopsIsKnownExploitedVulnerabilityQueryOperator {
        let obj = Object.assign(new AppSecopsIsKnownExploitedVulnerabilityQueryOperator(), model);
        AppSecopsIsKnownExploitedVulnerabilityQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsIsKnownExploitedVulnerabilityQueryOperator>): AppSecopsIsKnownExploitedVulnerabilityQueryOperator {
        if (!model) return null;
        return AppSecopsIsKnownExploitedVulnerabilityQueryOperator.newInstance(<AppSecopsIsKnownExploitedVulnerabilityQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsIsKnownExploitedVulnerabilityQueryOperator) {
        if (!obj) return;

        models.AppSecopsIsKnownExploitedVulnerabilityQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsIsKnownExploitedVulnerabilityQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AppSecopsIsKnownExploitedVulnerabilityQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Indicates if the component has a Known Exploited Vulnerability (KEV) to include
     */
    is_kev: boolean;

}
